import React from "react";
import { withTranslation } from "react-i18next";
import Modal from "../modal";
import get from "lodash/get";
import { RillContext } from "../../rill/RillReact/share/base";

class CancelAccount extends React.Component {
  render(ctx) {
    const { t } = this.props;
    const { activeUser, momentTZ, activeUserToRequest } = this.context.locals;
    const periodEnd = momentTZ(get(activeUserToRequest, "stripe.period_end")).format(
      "MMM. DD, YYYY"
    );
    return (
      <form method="POST" action="/actions/user/cancel-account">
        <Modal width="600px">
          <div className="head">
            <h2 className="alt">{t("cancelAccount.title")}</h2>
          </div>

          <div className="body">
            <p>
              <b>
                {t("cancelAccount.confirmMessage", { name: activeUser.name })}
              </b>{" "}
              {t("cancelAccount.sadToSeeYouGo")}{" "}
              <a href="/dashboard/support/contact">{t("cancelAccount.getInTouch")}</a>!
            </p>

            <p>
              {t("cancelAccount.enterPasswordBelow", { periodEnd: periodEnd })}
            </p>

            <p>
              {t("cancelAccount.dataDeletedAfter60Days")}
            </p>
            <p>
              <input
                type="password"
                placeholder={t("cancelAccount.passwordPlaceholder")}
                className="text-input"
                name="password"
              />
            </p>
          </div>

          <div className="foot">
            <button className="button-input full" type="submit">
              {t("cancelAccount.submitButton")}
            </button>
          </div>
        </Modal>
      </form>
    );
  }
}

CancelAccount.contextType = RillContext;

export default withTranslation("coaching-portal")(CancelAccount);
